<script setup>
import CustomTariffGrid from "@/components/CustomTariff/CustomTariffGrid.vue";
import CustomTariffParameters from "@/components/CustomTariff/CustomTariffParameters.vue";
import CustomTariffPaymentMethod from "@/components/CustomTariff/CustomTariffPaymentMethod.vue";
import CustomTariffPayment from "@/components/CustomTariff/CustomTariffPayment.vue";
import { onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();

const { push } = useRouter();

onBeforeMount(() => {
  const count = Object.values(store.state.customTariff.selectedTariffs).reduce(
    (acc, c) => acc + c,
    0
  );

  const phones = Object.values(store.state.customTariff.users).flat();
  const uniquePhones = Array.from(new Set(phones));

  if (count < 3) {
    {
      store.commit("system/SET_NOTIFICATION", {
        type: "error",
        message: `Выберите минимум 3 тарифа`,
      });
      push({ name: "ProfileCustomTariffSelect" });
    }
  }
  if (store.state.customTariff.months < 1) {
    store.commit("system/SET_NOTIFICATION", {
      type: "error",
      message: `Выберите длительность подписки`,
    });
    push({ name: "ProfileCustomTariffSelect" });
  }
  if (store.state.customTariff.accountsFormError) {
    store.commit("system/SET_NOTIFICATION", {
      type: "error",
      message: `Неверное заполнение формы`,
    });
    push({ name: "ProfileCustomTariffAccounts" });
  }
  if (phones.length !== uniquePhones.length) {
    store.commit("system/SET_NOTIFICATION", {
      type: "error",
      message: `Проверьте номера на уникальность`,
    });
    push({ name: "ProfileCustomTariffAccounts" });
  }
});
</script>

<template>
  <CustomTariffGrid>
    <CustomTariffParameters />
    <CustomTariffPaymentMethod />
    <CustomTariffPayment />
  </CustomTariffGrid>
</template>

<style scoped lang="scss"></style>
